<template>
  <div id="app" style=""
       :class="classApp"
       :style="styleApp"
  >

    <app-header v-if="isLog && !isApi && notLogin"></app-header>

    <search-panel></search-panel>

    <app-left-menu v-if="isLog && !isApi && notLogin"></app-left-menu>

    <layout v-if="!isApi"></layout>

    <quick-view></quick-view>

    <notifications :duration="3500" position="bottom right" animation-name="notificationcustomanim"
                   classes="notifications" :max="max"
                   width="400px"
                   style="width: auto; min-width: 0px; padding: 10px 20px;"
    >
      <template slot="body" slot-scope="props">
        <div v-if="props.item.type === 'is-danger-exclamation'"
             class="notification custom-notif has-text-white is-danger" @click="props.close">
          <span class="close">
            <i class="fal fa-times"></i>
          </span>
          <div v-if="props.item.title">
            <div class="notification-title">
              <i class="fas fa-lg" :class="notifIcon(props.item.type)"></i>{{props.item.title}}
              <div v-html="props.item.text" class="notification-content"></div>
              <!--<span class="is-pulled-right"><i class="fas fa-window-close"></i></span>-->
            </div>
          </div>
          <div v-else class="notification-title">
            <i class="fas fa-lg" :class="notifIcon(props.item.type)"></i>{{props.item.text}}
            <!--<span class="is-pulled-right"><i class="fas fa-window-close"></i></span>-->
          </div>
        </div>
        <div v-else class="notification custom-notif has-text-white" :class="props.item.type" @click="props.close">
          <span class="close">
            <i class="fal fa-times"></i>
          </span>
          <div v-if="props.item.title">
            <div class="notification-title">
              <i class="fas fa-lg" :class="notifIcon(props.item.type)"></i>{{props.item.title}}
              <div v-html="props.item.text" class="notification-content"></div>
              <!--<span class="is-pulled-right"><i class="fas fa-window-close"></i></span>-->
            </div>
          </div>
          <div v-else class="notification-title">
            <i class="fas fa-lg" :class="notifIcon(props.item.type)"></i>{{props.item.text}}
            <!--<span class="is-pulled-right"><i class="fas fa-window-close"></i></span>-->
          </div>
        </div>
      </template>
    </notifications>

    <notifications group="download" :duration="400000" width="400px" :max="1"
                   position="bottom center" animation-name="notificationcustomanim"
                   classes="notification--queue is-border">
    </notifications>

    <mobile-responsive-error></mobile-responsive-error>

    <modal></modal>
    <div class="notifications" v-show="documentLoading" style="width: 400px; bottom: 0px; left: calc(50% - 200px);">
      <span>
        <div data-id="4" class="notification-wrapper" style="transition: all 300ms ease 0s;">
          <div class="notification notification--queue">
            <div class="notification-title">
              <span class="delete is-medium"></span>
              <span class="is-uppercase">Préparation du téléchargement</span>
            </div>
            <div class="notification-content">
              <div>Génération du fichier
                <span class="icon is-pulled-right"><i class="fas fa-spinner fa-pulse"></i></span>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
  import 'vue-swatches/dist/vue-swatches.min.css'
  import { mapGetters, mapState } from 'vuex'
  import AppHeader from '@/components/layout/LayoutHeader'
  import AppLeftMenu from '@/components/layout/LayoutLeftMenu'
  import Layout from '@/components/layout/Layout'
  import SearchPanel from '@/components/layout/SearchPanel'
  import MobileResponsiveError from '@/components/layout/MobileResponsiveError'
  import QuickView from '@/components/quickview/QuickView'
  import Modal from '@/components/modal/Modal'
  import { bus, EVENTS } from '@/services/bus/index.js'

  export default {
    name: 'app',
    components: {
      AppHeader,
      AppLeftMenu,
      Layout,
      SearchPanel,
      MobileResponsiveError,
      QuickView,
      Modal
    },
    data: function () {
      return {
        classApp: [], // Classes sur la div "#app"
        styleApp: {
          height: '100%',
          overflow: 'hidden',
          overflowY: 'auto'
        }, // Style sur la div "#app"
        documentLoading: false,
        correctionVh: false
      }
    },
    computed: {
      ...mapGetters(['isLog', 'isSuperAdmin', 'isApi']),
      ...mapState(['device']),
      notLogin () {
        return this.$route.name !== 'Login'
      },
      notDashboard () {
        return this.$route.name !== 'Home'
      },
      max () {
        if (this.$route.name === 'Login') {
          return 1
        } else {
          return 3
        }
      }
    },
    methods: {
      notifIcon (val) {
        if (val === 'is-danger') return '' // fa-exclamation-triangle
        if (val === 'is-danger-exclamation') return 'fa-exclamation-circle'
        if (val === 'is-success') return 'fa-check-circle'
        if (val === 'is-warning') return 'fa-exclamation-triangle'
        if (val === 'is-info') return 'fa-bell'
        else return ''
      },
      checkNavigator () {
        // Vérifie si le navigateur est edge
        if (/Edge\/\d./i.test(navigator.userAgent)) {
          this.classApp.push('is-navigatorEdge')
        }

        // Vérifie si on est sur un iPAd
        const isIpad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
        // Vérifie si on est sur un android
        const isAndroid = (navigator.userAgent.match(/(Android)/))

        // Choix du device
        let device = null
        if (isIpad) device = 'ipad'
        if (isAndroid) device = 'android'
        if (device !== null) this.$store.commit('setDevice', { device: device }) // Mise à jour du store
      },
      setVhCorrection () {
        if (this.device === 'ipad') {
          // console.log('ios height fix enabled')
          this.correctionVh = window.innerHeight * 0.01
          document.documentElement.style.setProperty('--vh', `${this.correctionVh}px`)
          // Vue.set(this.styleApp, 'height', 'calc(' + this.correctionVh + ' * 100)')
        } else {
          // console.log('ios height fix NOT enabled')
        }
      }
    },
    mounted () {
      bus.$on(EVENTS.LOAD_DOCUMENT, () => {
        this.documentLoading = true
        // this.$notify({
        //   group: 'download',
        //   title: '<span class="delete is-medium"></span><span class="is-uppercase">Préparation du téléchargement</span>',
        //   text: '<div>Génération du fichier <span class="icon is-pulled-right"><i class="fas fa-spinner fa-pulse"></i></span></div>'
        // })
      })
      bus.$on(EVENTS.DOCUMENT_LOADED, () => {
        this.documentLoading = false
        // this.$notify({
        //   group: 'download',
        //   clean: true
        // })
      })
      this.checkNavigator()

      this.setVhCorrection()
      document.addEventListener('orientationchange', () => {
        this.setVhCorrection()
      })
    }
  }
</script>

<style lang="sass">
  @import './styles/app.sass'
  #app
    height: calc(var(--vh, 1vh) * 100) !important

  // Devise MAD
  .fa-mad-sign:before
    content: 'MAD'
  .fas.fa-mad-sign
    font-family: 'Roboto'
    font-weight: 500
  .icon.is-currency-mad
    &.is-small
      width: 2.5em
  .button.is-currency-mad
    &.is-square
      width: 5em
</style>



// WEBPACK FOOTER //
// src/App.vue